/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getSessionsAction } from "../actions/adminDashboardAction";

const initialState: any = {};

const guestUserSessions = createSlice({
  name: "Guest User Sessions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSessionsAction.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSessionsAction.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getSessionsAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default guestUserSessions.reducer;
